module.exports = __webpack_public_path__ + "b2a06a40bb824fa7a2c8690f19fcab9d.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-cl.png
// module id = 238
// module chunks = 30